import { CATEGORY_LABELS, CATEGORY_STORIES } from '@/constants/products'
import type { ProductCategory } from '@/schemas/product.schema'

export interface CategoryHeaderModelProps {
  category: ProductCategory
  count: number
}

export function useCategoryHeaderModel({
  category,
  count,
}: CategoryHeaderModelProps) {
  return {
    title: CATEGORY_LABELS[category],
    story: CATEGORY_STORIES[category],
    countLabel: `${count} ${count === 1 ? 'criação' : 'criações'}`,
  }
}
